import {BaseEntity} from "./BaseEntity";

export class Antenna implements BaseEntity {
    constructor(public readerID?: number,
                public id?: number,
                public number?: number,
                public alertingActionID?: number,
                public locationID?: number,
                public lastModifiedBy?:string) {
    }

    parseJson(json: any): void {
        this.readerID = json.readerID;
        this.id = json.id;
        this.number = json.number;
        this.alertingActionID = json.alertingActionID;
        this.locationID = json.locationID;
        this.lastModifiedBy = json.lastModifiedBy;
    }
}
